// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"w8-z","button":"x8-z","disabled":"y8-z","creditCard":"z8-z","wrapper":"A8-z"};